import { MenuItem, Select } from '@mui/material';

import { useSelector } from 'react-redux';
import { useState } from 'react';
import { selectMonth } from '../helper/filterOrder';

const FilterOrderByMonth = ({ setOrderdata }) => {
  const { ordersData } = useSelector((state) => state.order);
  const [defaultSelect, setDefaultSelect] = useState('all');
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;

  const handleSelect = async (event) => {
    setDefaultSelect(event.target.value);
    const seletctedData = await selectMonth(event.target.value, ordersData.data.data);
    setOrderdata(seletctedData);
  };
  return (
    <Select size='small' value={defaultSelect} onChange={handleSelect}>
      <MenuItem value='all' id='all'>
        Select Month
      </MenuItem>

      <MenuItem value={currentMonth} id={currentMonth}>
        This Month
      </MenuItem>

      <MenuItem
        value={currentMonth === 1 ? 12 : currentMonth - 1}
        id={currentMonth === 1 ? 12 : currentMonth - 1}
      >
        Last Month
      </MenuItem>
    </Select>
  );
};

export default FilterOrderByMonth;
